module.exports = __webpack_public_path__ + "static/img/partIcon01.d0210564.png";